module.exports = __webpack_public_path__ + "static/assets/d5e41a4426338560168e792cbf895daa.png";